import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';

function Contato() {
  return (
    <div className="container mt-5 text-white px-3">
      <div
        className="p-4 rounded-4 shadow-lg"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h2 className="mb-4 text-white text-center">
          <i className="bi bi-envelope-paper-fill me-2 text-info"></i>
          Fale Conosco
        </h2>

        <div className="mb-3">
          <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
          <strong>Endereço:</strong> R. Ernesto Geisel, 85 - Ouro Branco, Barreiras - BA
        </div>

        <div className="mb-3">
          <i className="bi bi-whatsapp me-2 text-success"></i>
          <strong>WhatsApp:</strong>{' '}
          <a
            href="https://wa.me/5577998485717"
            className="text-decoration-none"
            style={{ color: '#25D366' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            (77) 99848-5717
          </a>
        </div>

        <div className="mb-3">
          <i className="bi bi-envelope-at-fill me-2 text-warning"></i>
          <strong>E-mail:</strong>{' '}
          <a
            href="mailto:alamovinicius@infoserviceba.com.br"
            className="text-decoration-none"
            style={{ color: '#f0db4f' }}
          >
            alamovinicius@infoserviceba.com.br
          </a>
        </div>

        <div className="mt-4 d-flex justify-content-center">
          <iframe
            title="Mapa InfoService"
            src="https://maps.google.com/maps?q=R.%20Ernesto%20Geisel,%2085%20-%20Ouro%20Branco,%20Barreiras%20-%20BA&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="300"
            style={{
              border: '2px solid #0d6efd',
              borderRadius: '12px',
              boxShadow: '0 0 15px rgba(13, 110, 253, 0.4)',
              maxWidth: '600px'
            }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Contato;
